import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: `${theme.spacing(0.5)}px !important`,
    marginBottom: `${theme.spacing(1.5)}px !important`,
    backgroundColor: theme.palette.AdherenceCampaign.backgroundColor,
  },
  titleContainer: {
    padding: theme.spacing(2.5),
    '&, & .MuiAccordionSummary-content': {
      height: 'auto !important',
      minHeight: 'auto !important',
      margin: '0 !important',
    },
    '& .MuiAccordionSummary-content': {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
    },
    '& .MuiButtonBase-root': {
      color: theme.palette.AdherenceCampaign.titleColor,
      padding: '0 !important',
    },
  },
  titleIcon: {
    color: theme.palette.AdherenceCampaign.titleColor,
    '& .materialIcons': {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  title: {
    lineHeight: 1,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.AdherenceCampaign.titleColor,
  },
  detailsContainer: {
    gap: theme.spacing(1),
    flexDirection: 'column',
  },
  message: {
    lineHeight: 1.18,
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.AdherenceCampaign.textColor,
  },
  error: {},
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    '&$error $checkbox, &$error $checkboxLabel, ': {
      color: theme.palette.error.main,
    },
  },
  checkbox: {
    margin: 0,
    width: theme.typography.pxToRem(24),
    height: theme.typography.pxToRem(24),
  },
  checkboxLabel: {
    lineHeight: 1,
    cursor: 'pointer',
    textDecoration: 'underline',
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.AdherenceCampaign.textColor,
  },
  actionsContainer: {
    flex: 1,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    justifyContent: 'center',
  },
  deniedButton: {
    padding: 0,
    boxShadow: 'none',
    backgroundColor: '#ffffff00 !important',
    color: theme.palette.AdherenceCampaign.deniedButtonTextColor,
    '& .MuiButton-label': {
      lineHeight: 1,
      textDecoration: 'underline',
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.AdherenceCampaign.deniedButtonTextColor,
    },
    '&:hover': {
      boxShadow: 'none',
    },
    '&:focus': {
      outline: 0,
    },
  },
  allowedButton: {
    padding: theme.spacing(1, 1.5),
    borderRadius: theme.spacing(2.5),
    backgroundColor: theme.palette.AdherenceCampaign.allowedButtonColor,
    '& .MuiButton-label': {
      lineHeight: 1,
      display: 'flex',
      fontWeight: 'bold',
      flexDirection: 'row-reverse',
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.AdherenceCampaign.allowedButtonTextColor,
    },
    '&:focus': {
      outline: `2px solid ${theme.palette.AdherenceCampaign.allowedButtonColor}`,
    },
  },
  confirmButton: {
    padding: theme.spacing(1, 0),
    borderRadius: theme.spacing(2.5),
    backgroundColor: theme.palette.AdherenceCampaign.allowedButtonColor,
    '& .MuiButton-label': {
      lineHeight: 1,
      display: 'flex',
      fontWeight: 'bold',
      flexDirection: 'row-reverse',
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.AdherenceCampaign.allowedButtonTextColor,
    },
    '&:focus': {
      outline: `2px solid ${theme.palette.AdherenceCampaign.allowedButtonColor}`,
    },
  },
}))
